import React, { useState, useEffect } from "react";

function HomeTab(props) {
  // 줌 상태 관리 (상위에서 props로 받을 수 있도록 수정)"http://192.168.0.18:3000"
  const zoom = props.zoom ?? 1;
  const setZoom = props.setZoom ?? (()=>{});
  const showAllMarkers = props.showAllMarkers ?? true;
  const setShowAllMarkers = props.setShowAllMarkers ?? (()=>{});

  return (
    <div>
      {/* 배경 이미지와 제목/설명 */}
      <div
        style={{
          width: '100%',
          minHeight: '320px',
          backgroundImage: 'url("/title.PNG")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          textShadow: '0 2px 8px rgba(0,0,0,0.5)',
          padding: '48px 0 32px 0',
        }}
      >
        <h1 style={{ fontSize: '2.8rem', fontWeight: 'bold', marginBottom: 16, marginTop: 0 }}>
          버스 메모장
        </h1>
        <p style={{ fontSize: '1.3rem', margin: 0, fontWeight: 400 }}>
          여행을 기록하고 URL로 공유해 보세요.
        </p>
      </div>

      {/* 기존 안내 및 버튼 UI */}
      <div style={{ padding: 20 }}>
        {/* 예제 링크 버튼 */}
        <button
          style={{
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 22px',
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 5,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
          onClick={() => {
            window.open('https://koroute.netlify.app/#/map?routes=GGB234001739$31070$직행좌석$6801$37.4114167$127.1285$야탑역.종합버스터미널(전면)$36.9968833$127.14385$스타필드.용이푸르지오2차앞$배차: 10분 70분 70분;GGB214000022$31070$일반$1150, 70$36.99665$127.1442333$스타필드안성.용이동.삼천리가스$37.0071833$127.2708833$성모병원입구$배차: 9분 14분 14분;CAB285000107$34010$일반$201$37.0044113$127.26989739$인지사거리$36.817435$127.15115249$방죽안오거리$배차: 28분 -분 -분;CAB285000222$34010$일반$700$36.817435$127.15115249$방죽안오거리$36.67933$127.20402$전의역$배차: 65분 -분 -분;SJB293000331$12$간선$991$36.67939$127.20358$전의역$36.5296733$127.2646746$해밀동,산울동$배차: -분 -분 -분;DJB30300128$25$광역$B1$36.529377$127.264534$해밀리$36.33344$127.431404$대전역$배차: 10분 13분 15분;OCB276000092$33330$일반$607$36.333354$127.431502$대전역$36.299573$127.566392$옥천버스앞$배차: -분 -분 -분;OCB276000056$33330$일반$721$36.299396$127.566305$옥천버스터미널$36.242958$127.694873$절골$배차: -분 -분 -분;TSB277000037$33340$농어촌(일반)$420$36.237808$127.7210369$심천역$36.171746$127.7855489$영동역$배차: 220분 -분 -분;TSB277000063$33340$농어촌(일반)$612$36.171746$127.7855489$영동역$36.211868$127.9988759$추풍령$배차: 280분 -분 -분;GCB47201669$37030$일반$11-6$36.211842$127.999138$추풍령종점$36.123772$128.118011$김천시외버스터미널$배차: -분 -분 -분;TSB368000089$37380$농어촌(일반)$14$36.123352$128.1184549$김천 공영버스터미널$35.916608$128.2854319$성주창의문화센터(종점)$배차: 380분 -분 -분;TSB368000096$37380$농어촌(일반)$250$35.916835$128.2847641$성주창의문화센터(기점)$35.851305$128.49498$성서주공1단지건너$배차: 55분 -분 -분;DGB1000005000$22$급행$급행5$35.85025$128.49222$계명대역(4번출구)$35.9128$128.818$하양초등학교$배차: -분 -분 -분;YCB357000446$37070$지선$55$35.912736$128.818003$하양초등학교$35.960846$128.927512$영천버스터미널앞$배차: -분 -분 -분;YCB357000333$37070$지선$763$35.96051$128.927914$영천터미널$35.881828$129.025478$효리초입(효리방면)$배차: -분 -분 -분;KUB352000319$37020$일반$301$35.89313333$129.05035$아화정류장$35.838449$129.204193$고속버스.시외버스터미널$배차: 30분 -분 -분;KUB352000235$37020$일반$600$35.838449$129.204193$고속버스.시외버스터미널$35.682526$129.33169$(구)모화역,울산방면$배차: 10분 -분 -분;USB196000446$26$좌석$1432, 122$35.68244216$129.33172641$모화$35.61150538$129.35719231$농소공영차고지$배차: 100분 -분 -분;USB195000247$26$좌석$1224$35.61141309$129.35748759$농소공영차고지$35.28333284$129.09497371$노포동역(종점)$배차: 24분 -분 -분&title=URL 그룹', '_blank');
          }}
        >
          예제 링크
        </button>
        {/* 안내 문구 */}
        
        <div style={{ margin: '24px 0' }}>
          <label style={{ fontWeight: 'bold', marginRight: 8 }}>지도에 마커 표시</label>
          <button
            onClick={() => setShowAllMarkers(v => !v)}
            style={{
              padding: '6px 18px',
              fontSize: 16,
              background: showAllMarkers ? '#27ae60' : '#aaa',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            {showAllMarkers ? 'ON' : 'OFF'}
          </button>
        </div>
        <span style={{ marginRight: 8, fontSize: 12}}>
          ⚠️데이터, 쿠키 삭제 시 저장된 노선이 사라집니다. 카카오맵 등 지도 앱과 같이 사용하는 것을 권장합니다. 교통 정보 출처는 서울시 및 국토교통부입니다. 따라서 일부 지역의 경우 노선 검색에 제외되었으며 실제 정보와 다를 수 있습니다. 비수도권 노선의 경우 버스 경로도가 정류장 간 직선으로 이어집니다.
        </span>
      </div>
    </div>
  );
}

export default HomeTab;
